import React from "react"
import AdminHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";
import AdminFooter from "./AdminFooter";
import {GetData} from "../api_key/GetData";
import {Alert, Button, Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {PostData} from "../api_key/PostData";

class AdminContactUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            commonAlert: {
                show: false,
                variant: "",
                message: ""
            },
            contactUsColumns: [],
            contactusData: [],
        }
        document.title = this.props.pageTitle
        this.loadAllContactUs = this.loadAllContactUs.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleDeleteContactUs = this.handleDeleteContactUs.bind(this)
    }
    componentDidMount() {
        const cookieDataReplace = document.cookie.split('; ').find((row) => row.startsWith('mokhasanLogin='))
        let sessionData = JSON.parse(cookieDataReplace.replace('mokhasanLogin=', ''));

        this.setState({
            loginUsername: sessionData[0].full_name,
            loginUserUUID: sessionData[0].uuid,
            loginUserToken: sessionData[0].token
        });
        this.loadAllContactUs()
    }
    handleDeleteContactUs() {
        PostData("/contactus/delete_contact_us", {uuid: this.state.uuid})
            .then(result => {
                if (result.status) {
                    this.setState({
                        commonAlert: {
                            show: false,
                            variant: "success",
                            message: "Contact entry deleted successfully"
                        }
                    })
                }
            })
        this.loadAllContactUs()
        this.handleClose()
    }


    loadAllContactUs() {
        GetData("/contactus/get_all")
            .then(result => {
                this.setState({
                    contactusData: result.response,
                    contactUsColumns: [
                        {
                            name: <p className="h6 font-weight-bold">Name</p>,
                            selector: (row) => row.name,
                            sortable: true
                        },
                        {
                            name: <p className="h6 font-weight-bold">E-Mail</p>,
                            selector: (row) => row.email,
                            sortable: true
                        },
                        {
                            name: <p className="h6 font-weight-bold">Phone</p>,
                            selector: (row) => row.phone,
                            sortable: true
                        },
                        {
                            name: <p className="h6 font-weight-bold">Website</p>,
                            selector: (row) => row.website,
                            sortable: true
                        },
                        {
                            name: <p className="h6 font-weight-bold">Message</p>,
                            selector: (row) => row.description,
                            sortable: true
                        },
                        {
                            name: <p className="h6 font-weight-bold">Delete</p>,
                            cell: (data) => <Button variant="danger" className="my-2" onClick={() => {
                                this.setState({
                                    handleDeletePopup: true,
                                    uuid: data.uuid,
                                })
                            }}>
                                <em className="fa fa-trash"></em>
                            </Button>
                        },
                    ],
                })
            })
    }
    handleClose() {
        this.setState({
            handleDeletePopup: false,
            commonAlert: {
                show: false,
                variant: "",
                message: ""
            },
        })
    }
    render() {
        return (<>
            <AdminSidebar/>

            <div className="content">
                <div>
                    <AdminHeader/>

                    <div className="container-fluid pt-4 px-4">
                        <Alert show={this.state.commonAlert.show} variant={this.state.commonAlert.variant}
                               className="rounded-lg">
                            <h6 className="m-0 font-weight-bold">{this.state.commonAlert.message}</h6>
                        </Alert>
                        <Modal show={this.state.handleDeletePopup} onHide={this.handleClose} centered backdrop="static"
                               keyboard={false}>
                            <Modal.Header className="justify-content-center">
                                <Modal.Title>Are you sure want to delete this contact entry?</Modal.Title>
                            </Modal.Header>
                            <Modal.Footer className="justify-content-center">
                                <Button variant={"primary"} onClick={this.handleDeleteContactUs}>Yes</Button>
                                <Button variant={"danger"} onClick={this.handleClose}>No</Button>
                            </Modal.Footer>
                        </Modal>
                        <div className="row g-4">
                            <div className="col-sm-12">
                                <div className="shadow rounded p-4 table-responsive">
                                    <DataTable
                                        columns={this.state.contactUsColumns}
                                        data={this.state.contactusData}
                                        pagination
                                        className={"table-hover"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AdminFooter/>
            </div>
        </>);
    }
}

export default AdminContactUs;